import { render, staticRenderFns } from "./CbsReportReview.vue?vue&type=template&id=e87b51de&"
import script from "./CbsReportReview.vue?vue&type=script&lang=ts&"
export * from "./CbsReportReview.vue?vue&type=script&lang=ts&"
import style0 from "./CbsReportReview.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports